import { logError } from './log'

function fallbackCopyTextToClipboard({ text }: { text: string }) {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.append(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (error) {
    logError('Fallback: Oops, unable to copy', error)
  }

  textArea.remove()
}

export const copyTextToClipboard = ({ text }: { text: string }) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard({ text })
    return
  }
  navigator.clipboard.writeText(text).then(
    () => {},
    (error) => {
      logError('Async: Could not copy text:', error)
    },
  )
}
